function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2250",
  "data-name": "Group 2250",
  transform: "translate(-62.5 -83.9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1255",
  "data-name": "Path 1255",
  d: "M103.836,92.909l-.554-4.574-1.906.243L100.2,83.9,62.5,93.5l4.262,16.735.139,1.247v.936h38.911V92.874h-1.975Zm-1.628-3.188.381,3.188h-26.4ZM99.3,85.39l.832,3.326L73.692,91.939ZM64.025,94.4l.8-.208.762,6.271Zm2.876,6.687-.832-6.964.832-.1Zm37.663,10.083H68.148V94.156h36.416Z",
  fill: "#0055c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1256",
  "data-name": "Path 1256",
  d: "M85.683,130.875v.589h28.793v-.589a1.62,1.62,0,0,1,1.594-1.629h.589V118.818h-.589a1.6,1.6,0,0,1-1.594-1.629V116.6H85.683v.589a1.62,1.62,0,0,1-1.594,1.629H83.5v10.429h.589A1.62,1.62,0,0,1,85.683,130.875Zm-1-10.914a2.837,2.837,0,0,0,2.148-2.148h26.541a2.837,2.837,0,0,0,2.148,2.148V128.1a2.837,2.837,0,0,0-2.148,2.148H86.826a2.837,2.837,0,0,0-2.148-2.148Z",
  transform: "translate(-13.724 -21.37)",
  fill: "#0055c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1257",
  "data-name": "Path 1257",
  d: "M159.487,135.974a2.287,2.287,0,1,0-2.287-2.287A2.307,2.307,0,0,0,159.487,135.974Zm0-3.292a1,1,0,1,1-1,1A1.006,1.006,0,0,1,159.487,132.682Z",
  transform: "translate(-61.888 -31.042)",
  fill: "#0055c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1258",
  "data-name": "Path 1258",
  d: "M94.587,135.974a2.287,2.287,0,1,0-2.287-2.287A2.263,2.263,0,0,0,94.587,135.974Zm0-3.292a1,1,0,1,1-1,1A.984.984,0,0,1,94.587,132.682Z",
  transform: "translate(-19.475 -31.042)",
  fill: "#0055c6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1259",
  "data-name": "Path 1259",
  d: "M122.25,133.671a4.886,4.886,0,1,0-4.851-4.885A4.873,4.873,0,0,0,122.25,133.671Zm0-8.489a3.638,3.638,0,1,1-3.6,3.638A3.586,3.586,0,0,1,122.25,125.182Z",
  transform: "translate(-35.877 -26.14)",
  fill: "#0055c6"
}));

function SvgBills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.311,
    height: 28.516,
    viewBox: "0 0 43.311 28.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.fca83196.svg";
export { ForwardRef as ReactComponent };